import { Component, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemsService } from '../../../../services/items.service';
import { FormBuilder, FormControl, FormGroup, Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import Swal from 'sweetalert2';
import { HomeService } from '../../../../services/home.service';
import { Stockitem } from '../../../../interfaces/stockitem';
import { users } from '../../../../interfaces/users';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { SelectedProductDetail } from '../../../../interfaces/addorder';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { OrdersService } from '../../../../services/orders';
import { GovernoratesService } from '../../../../services/governorates.service';
import { BundleService } from '../../../../services/bundles';
import { TranslocoService } from '@ngneat/transloco';
// Internal type aliases for readability (no runtime impact)
type Bundle = any;
type StockItem = Stockitem;
type UserData = any;

@Component({
  selector: 'app-addorder',
  templateUrl: './addorder.component.html',
  styleUrl: './addorder.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AddorderComponent {
  // ===============================
  // UI State & Flags
  // ===============================
  contentReady = false;
  isMobile = false;
  isAr = false;
  isUpdate = false;
  inUpdatePage = false;
  displaybutton = false;
  clearClientBtn = false;
  clearcart = false;
  showAllUsers = false;
  warehouseIsStore = false;
  isCompany = false;
  isWarehouse = false;
  isStore = false;
  isClinic = false;
  isStoreAndClinic = false;
  hasToken = false;
  hasQrOffer = false;
  classToggled = false;
  selectedValueFromStock = true;
  cartItems: any[] = [];
  backendErrors: string[] = [];
  submitted = false;
  // ===============================
  // Form & Data Models
  // ===============================
  data!: FormGroup;
  dataForm!: FormData;

  // Client Information
  client_name = '';
  phone_number = '';
  another_phone = '';
  address = '';

  // Order Details
  delivery_fees = '';
  note = '';
  total = 0;
  income = 0;
  due: any = '';
  totalOriginalPrice = 0;
  totalUserEnteredPrice = 0;
  originalPrice = 0;
  bonus = 0;

  // Selection & Filtering
  selectedProduct: StockItem | null = null;
  selectedProductFromStock = '';
  selectedProductsDetails: SelectedProductDetail[] = [];
  selectedBundlesDetails: any[] = [];
  productname: StockItem[] = [];
  productnamefixed: StockItem[] = [];
  bundles: Bundle[] = [];
  filteredBundles: Bundle[] = [];
  filteredProviders: StockItem[] = [];
  users: UserData[] = [];
  governorates: any[] = [];
  cities: any[] = [];

  // Search values for autocomplete
  searchValue = '';
  bundleSearchValue = '';

  // Arrays for Order Submission
  arrayofitems: string[] = [];
  arrayofOlditems: number[] = [];
  arrayofqty: (number | null)[] = [];
  arrayofprices: (number | null)[] = [];
  arrayofids: (number | null)[] = [];
  arrayofbounes: number[] = [];

  // Location & Warehouse
  government_id: any = '';
  city_id: any = '';
  warehouseId: string | null = null;
  countryId!: number;
  selectedCountry: string | null = null;

  // User & Account
  userId = '';
  thisUserId: any = null;
  accounttype: string | null = null;
  createOrderByid: any = null;
  createOrderByidType: any = null;

  // Product Selection State
  productnameselectedvalu = 'select product';
  selectedProductLength = 0;
  productindex = 0;
  productqtyindex = 0;
  productpriceindex = 0;

  // Update Context
  updateId: any = null;

  // ===============================
  // View Children
  // ===============================
  @ViewChild('productSelect', { static: false }) productSelect!: ElementRef;

  // ===============================
  // Constructor
  // ===============================
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private _homeService: HomeService,
    private _orderService: OrdersService,
    private _userService: UserService,
    private _bundleService: BundleService,
    private governoratesService: GovernoratesService,
    private deviceService: DeviceDetectorService,
    private transloco: TranslocoService
  ) { }

  private t(key: string, params?: Record<string, unknown>): string {
    return this.transloco.translate(key, params);
  }

  // ===============================
  // Lifecycle
  // ===============================
  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') === 'ar';
    this.hasToken = !!localStorage.getItem('token');
    this.warehouseId = localStorage.getItem('posId');
    this.accounttype = String(this.checkAccountType());
    this.loadGovernorates();
    this.getUserId();
    this.displaybutton = this.arrayofitems.length !== 0;
    this.getAllStockData();
    this.getAllBundles();
    this.getAllUsers();
    this.initiate();
    this.listenToAddressChanges();
    this.restoreCartFromStorage();
    this.restoreClientFromStorage();
    this.handleQueryParamCart();

  }
get hasBundles(): boolean {
  return Array.isArray(this.bundles) && this.bundles.length > 0;
}
  // ===============================
  // Price Calculation Helpers (Extracted)
  // ===============================
  private getProductPriceByAccountType(product: StockItem): number {
    switch (this.accounttype) {
      case '2': return Number(product.affiliationprice) ?? 0;
      case '3': return Number(product.pricea ?? 0);
      case '4': return Number(product.priceb ?? 0);
      case '5': return Number(product.pricec ?? 0);
      default: return Number(product.price ?? 0);
    }
  }

  private getBundlePriceByAccountType(bundle: Bundle): number {
    switch (this.accounttype) {
      case '2': return bundle.affiliationprice ?? 0;
      case '3': return bundle.pricea ?? 0;
      case '4': return bundle.priceb ?? 0;
      case '5': return bundle.pricec ?? 0;
      default: return bundle.price ?? 0;
    }
  }

  // Kept as-is to preserve behavior (public API used in template)
  getBundlePrice(bundle: any): number {
    return this.getBundlePriceByAccountType(bundle);
  }

  // ===============================
  // Form Initialization
  // ===============================
  private initiate(): void {
    this.data = this.fb.group({
      client_name: ['', Validators.required],
phone_number: [
  '',
  [
    Validators.required,
    this.realEgyptOrKsaPhoneValidator
  ],
],
another_phone: [
  '',
  [
    Validators.required,
    this.realEgyptOrKsaPhoneValidator
  ],
],
      building_number: ['', Validators.required],
      street: ['', Validators.required],
      landmark: ['', Validators.required],
      floor: ['', Validators.required],
      home: ['', Validators.required],
      address: ['', Validators.required],
      quantity: [''],
      city_id: ['', Validators.required],
      government_id: ['', Validators.required],
      item: [''],
      createby: [''],
      price: [''],
      bounes: [''],
      delivery_fees: ['', Validators.required],
      note: [''],
      arrayofids: ['']
    });
  }
  realEgyptOrKsaPhoneValidator = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) return null;

  const rawValue = String(control.value).trim();

  // يمنع الأرقام العربي والحروف العربي
  const arabicRegex = /[\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]/;
  if (arabicRegex.test(rawValue)) {
    return { arabicNotAllowed: true };
  }

  // يشيل مسافات وشرطات وأقواس فقط
  const phone = rawValue.replace(/[\s\-()]/g, '');

  const egyptMobileRegex =
    /^(01[0125]\d{8}|\+201[0125]\d{8}|00201[0125]\d{8})$/;

  const ksaMobileRegex =
    /^(05\d{8}|\+9665\d{8}|009665\d{8})$/;

  const isValidEgypt = egyptMobileRegex.test(phone);
  const isValidKsa = ksaMobileRegex.test(phone);

  return isValidEgypt || isValidKsa
    ? null
    : { invalidEgyptOrKsaPhone: true };
};

  shouldShowError(controlName: string): boolean {
    const control = this.data?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  hasNoSelectedItems(): boolean {
    return this.selectedProductsDetails.length === 0 && this.selectedBundlesDetails.length === 0;
  }

  shouldShowItemsError(): boolean {
    return this.submitted && this.hasNoSelectedItems();
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.data?.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors['required']) {
      return this.t('field_required', { label });
    }

    if (control.errors['invalidEgyptOrKsaPhone']) {
      return this.t('valid_egypt_ksa_mobile', { label });
    }

    if (control.errors['arabicNotAllowed']) {
      return this.t('english_digits_without_arabic', { label });
    }

    return this.t('field_invalid', { label });
  }

  getMissingRequiredCount(): number {
    if (!this.data) {
      return 0;
    }

    return Object.keys(this.data.controls).filter((controlName) => {
      const control = this.data.get(controlName);
      return control?.hasError('required');
    }).length + (this.hasNoSelectedItems() ? 1 : 0);
  }

  private validateBeforeSubmit(): boolean {
    this.submitted = true;
    this.backendErrors = [];

    if (this.data.invalid || this.hasNoSelectedItems()) {
      this.data.markAllAsTouched();

      Swal.fire({
        icon: 'warning',
        title: this.t('Please check order data'),
        text: this.t('Review the messages below the required or invalid fields'),
        confirmButtonText: this.t('OK'),
      });

      return false;
    }

    return true;
  }
  // ===============================
  // Address Logic (Extracted)
  // ===============================
  private buildAddressFromParts(values: any): string {
    const parts = [
      values.building_number ? `${this.t('address_building_prefix')} ${values.building_number}` : '',
      values.street ? `${this.t('address_street_prefix')} ${values.street}` : '',
      values.landmark ? `${this.t('address_landmark_prefix')}: ${values.landmark}` : '',
      values.floor ? `${this.t('address_floor_prefix')} ${values.floor}` : '',
      values.home ? `${this.t('address_apartment_prefix')} ${values.home}` : '',
    ].filter(Boolean);
    return parts.join(' - ');
  }

  private listenToAddressChanges(): void {
    this.data.valueChanges.subscribe(values => {
      const fullAddress = this.buildAddressFromParts(values);
      this.address = fullAddress;
      this.data.patchValue({ address: fullAddress }, { emitEvent: false });
    });
  }

  // ===============================
  // Validator (Fixed Binding)
  // ===============================
  englishDigitsOnlyValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const arabicRegex = /[\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]/;
    return arabicRegex.test(control.value)
      ? { arabicNotAllowed: true }
      : null;
  };

  // ===============================
  // Data Loading Methods
  // ===============================
getAllBundles(): void {
  if (!this.warehouseId) return;

  this._bundleService.getAll(Number(this.warehouseId)).subscribe({
    next: (res) => {
      const loadedBundles = Array.isArray(res?.bundles) ? res.bundles : [];

      this.bundles = loadedBundles;
      this.filteredBundles = [...loadedBundles];
    },
    error: (err) => {
      console.error('Failed to load bundles:', err);
      this.bundles = [];
      this.filteredBundles = [];
    },
  });
}
  getAllStockData(): void {
    const posId = localStorage.getItem('posId');
    if (!posId) return;

    this._orderService.getStocksData(posId).subscribe({
      next: (data) => {

        this.productname = data.stocks
          .filter((item: StockItem) => Number(item.quantity) > 0) // 👈 هنا بنشيل اللي كميته 0
          .sort((a: StockItem, b: StockItem) =>
            a.name_ar.localeCompare(b.name_ar, 'ar', { sensitivity: 'base' })
          );

        this.filteredProviders = [...this.productname];

        if (this.inUpdatePage) {
          this.buildSelectedProductsFromParams();
        }
      },
      error: (error) => console.error('Failed to load stock data:', error),
    });
  }

  getAllUsers(): void {
    this.contentReady = true;
    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.users = this.filterUsersByType(data.reverse());
        this.contentReady = false;
      },
      error: (error) => console.error('Failed to load users:', error),
    });
  }

  loadGovernorates(): void {
    this.contentReady = true;
    this.governoratesService.getAllGovernorates().subscribe({
      next: (data) => {
        this.governorates = data;
        this.contentReady = false;
      },
      error: (err) => console.error('Failed to load governorates:', err),
    });
  }

  loadCities(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const governorateId = Number(selectElement.value);
    if (!governorateId) {
      this.cities = [];
      return;
    }
    this.governoratesService.getCity(governorateId).subscribe({
      next: (res) => {
        this.cities = res;
        this.contentReady = false;
      },
      error: (err) => {
        console.error('Error loading cities', err);
        this.cities = [];
      }
    });
  }

  // ===============================
  // User & Account Methods
  // ===============================
  getUserId(): void {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.thisUserId = data['user_id'];
      },
      error: (error) => console.error('Failed to get user ID:', error),
    });
  }

  checkAccountType(): string {
    this._userService.getAccountType().subscribe({
      next: (data) => {
        this.accounttype = data['user_type'];
        if (this.accounttype === '1' || this.accounttype === '6') {
          this.showAllUsers = true;
        }
      },
      error: (error) => console.error('Failed to get account type:', error),
    });
    return this.accounttype ?? '';
  }

  filterUsersByType(users: users[], typeToMatch: string = this.thisUserId): users[] {
    return users.filter(user => user.id !== typeToMatch);
  }

  // ===============================
  // Bundle Handlers (Chip + Autocomplete)
  // ===============================
  onBundleSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input?.value || '';
    this.bundleSearchValue = value;
    const search = value.toLowerCase();
    this.filteredBundles = this.bundles.filter((b) =>
      b.name_ar?.toLowerCase().includes(search)
    );
  }

  addBundle(event: MatAutocompleteSelectedEvent): void {
    const bundle = event.option.value;
    const exists = this.selectedBundlesDetails.find(
      x => x.bundle.id === bundle.id
    );
    if (!exists) {
      this.selectedBundlesDetails.push({
        bundle,
        quantity: 1,
        price: this.getBundlePriceByAccountType(bundle)
      });
    }
    this.bundleSearchValue = '';
  }

  removeBundle(id: number): void {
    this.selectedBundlesDetails =
      this.selectedBundlesDetails.filter(b => b.bundle.id !== id);
  }

  trackByBundle(index: number, item: any) {
    return item.bundle.id;
  }

  // ===============================
  // Product Selection Handlers (Chip + Autocomplete)
  // ===============================
  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input?.value || '';
    this.searchValue = value;
    const search = value.toLowerCase();
    this.filteredProviders = this.productname.filter(p =>
      p.name_ar?.toLowerCase().includes(search) ||
      p.name_en?.toLowerCase().includes(search)
    );
  }

  addProduct(event: MatAutocompleteSelectedEvent): void {
    const product = event.option.value;
    const exists = this.selectedProductsDetails.find(
      x => x.product.id === product.id
    );
    if (!exists) {
      this.selectedProductsDetails.push({
        product,
        quantity: 1,
        price: this.getProductPriceByAccountType(product),
        bounes: null
      });
    }
    this.searchValue = '';
  }

  removeProduct(id: number): void {
    this.selectedProductsDetails =
      this.selectedProductsDetails.filter(p => p.product.id !== id);
  }

  trackByProduct(index: number, item: any) {
    return item.product.id;
  }

  onitemchange(input: string): void {
    const match = input.match(/^(\d+)type(\d+)$/);
    if (match) {
      const [, id, type] = match;
      this.createOrderByid = id;
      this.createOrderByidType = type;
    } else {
      console.error('Input format is invalid.');
    }
  }

  // ===============================
  // Cart & Client Restoration
  // ===============================
  private restoreCartFromStorage(): void {
    const storedCart = localStorage.getItem('cart');
    if (storedCart && storedCart !== '[]') {
      this.clearcart = true;
      const cartItems = JSON.parse(storedCart);
      this.selectedValueFromStock = false;
      this.selectedProductsDetails = cartItems.map((item: StockItem) => ({
        product: item,
        quantity: 1,
        price: this.getProductPriceByAccountType(item),
        bounes: null
      }));
    }
  }

  private restoreClientFromStorage(): void {
    const storedClient = localStorage.getItem('clientinfo');
    if (storedClient) {
      this.clearClientBtn = true;
      const client = JSON.parse(storedClient);
      this.client_name = client['client_name'] ?? '';
      this.phone_number = client['phone_number'] ?? '';
      this.another_phone = client['another_phone'] ?? '';
      this.address = client['address'] ?? '';
    }
  }

  private handleQueryParamCart(): void {

    this.route.queryParams.subscribe(params => {
      const cartParam = params['cart'];
      if (cartParam) {
        try {

          const cartItems = JSON.parse(cartParam);
          this.warehouseId = params['warehouseIdFromCart'] ?? this.warehouseId;
          console.log('Received cart from query params:', this.warehouseId);
          this.cartItems = cartItems;
          this.selectedValueFromStock = false;
          this.selectedProductsDetails = cartItems.map((item: StockItem) => ({
            product: item,
            quantity: 1,
            price: this.getProductPriceByAccountType(item),
            bounes: null
          }));
        } catch (error) {
          console.error('Invalid cart data:', error);
        }
      }
    });
  }

  // ===============================
  // Order Submission Logic
  // ===============================
  submitSelectedProducts(): void {
    this.arrayofitems = [];
    this.arrayofids = [];
    this.arrayofprices = [];
    this.arrayofqty = [];
    this.arrayofOlditems = [];
    this.arrayofbounes = [];
    this.totalOriginalPrice = 0;
    this.totalUserEnteredPrice = 0;

    for (const item of this.selectedProductsDetails) {
      const product = item.product;
      const quantity = item.quantity ?? 0;
      const enteredPrice = item.price ?? 0;
      this.originalPrice = this.getProductPriceByAccountType(product);
      this.arrayofOlditems.push(this.originalPrice);
      this.arrayofitems.push(product.name_ar);
      this.arrayofids.push(product.id);
      this.arrayofprices.push(enteredPrice);
      this.arrayofqty.push(quantity);
      this.arrayofbounes.push(item.bounes ?? 0);
      this.totalOriginalPrice += this.originalPrice * quantity;
      this.totalUserEnteredPrice += enteredPrice * quantity;
    }

    this.income = this.totalOriginalPrice;
    if (this.accounttype === '2') {
      this.due = Math.round(this.totalUserEnteredPrice) - Math.round(this.totalOriginalPrice);
    } else {
      if (this.createOrderByid != null && this.createOrderByidType === '2') {
        this.due = Math.round(this.totalUserEnteredPrice) - Math.round(this.totalOriginalPrice);
      } else {
        this.due = '';
      }
    }
    this.total = this.totalUserEnteredPrice;
  }

  // Renamed internally (typo fix) - safe as it's only called within this class
  private appendPostData(): void {
    this.total = Number(this.total) || 0;

    for (const bundle of this.selectedBundlesDetails) {
      const bundleItemsText = bundle.bundle.items
        .map((item: any) => `${item.stock.name_ar} x${item.quantity}`)
        .join(' , ');
      const fullBundleName = `${bundle.bundle.name_ar} : ${bundleItemsText}`;
      const price = bundle.price ?? bundle.bundle.price;
      const quantity = bundle.quantity ?? 1;

      this.arrayofitems.push(fullBundleName);
      this.arrayofqty.push(quantity);
      this.arrayofprices.push(price);
      this.total += price * quantity;
    }

    this.dataForm = new FormData();
    this.dataForm.append('client_name', this.client_name);
    this.dataForm.append('phone_number', this.phone_number);
    this.dataForm.append('another_phone', this.another_phone);
    this.dataForm.append('total', String(this.total + parseInt(this.delivery_fees || '0')));
    this.dataForm.append('income', String(this.income));
    this.dataForm.append('note', this.note || '');
    this.dataForm.append('address', this.address);
    this.dataForm.append('grov_id', String(this.government_id));
    this.dataForm.append('city_id', String(this.city_id));
    this.dataForm.append('due', String(this.due));
    this.dataForm.append('duenow', String(this.due));
    this.dataForm.append('delivery_fees', this.delivery_fees || '0');
    for (let i = 0; i < this.arrayofitems.length; i++) {

      this.dataForm.append('item[]', this.arrayofitems[i]);

      this.dataForm.append(
        'quantity[]',
        String(this.arrayofqty[i] ?? 1)
      );

      this.dataForm.append(
        'price[]',
        String(this.arrayofprices[i] ?? 0)
      );

      this.dataForm.append(
        'itemsprices[]',
        String(this.arrayofOlditems[i] ?? 0)
      );

      this.dataForm.append(
        'product_id[]',
        String(this.arrayofids[i] ?? 0)
      );

    }

    this.selectedBundlesDetails.forEach((bundle: any, index: number) => {
      this.dataForm.append(`bundle_id[${index}]`, String(bundle.bundle.id));
      this.dataForm.append(`bundle_qty[${index}]`, String(bundle.quantity ?? 1));
      this.dataForm.append(`bundle_price[${index}]`, String(bundle.price ?? bundle.bundle.price));
    });

    this.dataForm.append('order_status', '1');
    this.dataForm.append('user_id', this.createOrderByid ?? this.thisUserId);
    this.dataForm.append('warehouse_id', String(this.warehouseId));
  }

  // ===============================
  // Bundle Calculations (KEPT - Required for onSubmit)
  // ===============================
  calculateBundlesAffiliate(): void {
    if (!this.selectedBundlesDetails?.length) return;
    let bundleOriginalTotal = 0;
    let bundleEnteredTotal = 0;
    for (const b of this.selectedBundlesDetails) {
      const bundle = b.bundle;
      const qty = b.quantity ?? 1;
      const originalPrice = this.getBundlePriceByAccountType(bundle);
      const enteredPrice = Number(b.price) || originalPrice;
      bundleOriginalTotal += originalPrice * qty;
      bundleEnteredTotal += enteredPrice * qty;
    }
    const bundleDue = Math.round(bundleEnteredTotal) - Math.round(bundleOriginalTotal);
    this.due = Number(this.due || 0) + bundleDue;
    this.income = Number(this.income || 0) + bundleDue;
  }

  // ===============================
  // Action Methods
  // ===============================
  onSubmit(): void {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.submitSelectedProducts();
    this.calculateBundlesAffiliate();
    this.appendPostData();

    this._orderService.addOrder(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.t('Order Placed'),
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
        localStorage.removeItem('clientinfo');
        if (this.hasQrOffer) {
          this.generateQr(res['order'].id, res['client'].id, this.thisUserId);
        }
        this.router.navigateByUrl(this.isMobile ? '/orders.mobile' : '/Orders');
      },
      error: (err) => {
        this.showBackendErrors(err);
        this.contentReady = false;
      },
    });
  }

  updateOrder(): void {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.submitSelectedProducts();
    this.appendPostData();

    this._orderService.updateOrder(this.updateId, this.dataForm).subscribe({
      next: () => {
        Swal.fire({
          icon: 'success',
          title: this.t('Order Placed'),
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;
        localStorage.removeItem('cart');
        localStorage.removeItem('cartWarehouseId');
        localStorage.removeItem('clientinfo');
        this.router.navigateByUrl(this.isMobile ? '/orders.mobile' : '/Orders');
      },
      error: (err) => {
        this.showBackendErrors(err);
        this.contentReady = false;
      },
    });
  }

  clearClient(): void {
    localStorage.removeItem('clientinfo');
    this.clearClientBtn = false;
    this.client_name = '';
    this.phone_number = '';
    this.another_phone = '';
    this.address = '';
  }

  clearProduct(): void {
    localStorage.removeItem('cart');
    localStorage.removeItem('cartWarehouseId');
    this.clearcart = false;
  }

  buildSelectedProductsFromParams(): void {
    this.selectedProductsDetails = [];
    for (let i = 0; i < this.arrayofids.length; i++) {
      const id = +this.arrayofids[i]!;
      const name = this.arrayofitems[i];
      const qty = +this.arrayofqty[i]!;
      const price = +this.arrayofprices[i]!;
      const bounes = +this.arrayofbounes[i];
      const product = this.filteredProviders.find(p => p.id === id);
      if (product) {
        this.selectedProductsDetails.push({
          product,
          quantity: qty,
          price: price,
          bounes: bounes || null
        });
      } else {
        console.warn(`⛔ Product not found for ID: ${id}`, { name, qty, price });
      }
    }
    this.contentReady = false;
  }
private fieldLabel(field: string): string {
  const labels: Record<string, string> = {
    client_name: 'client name',
    phone_number: 'Phone Number',
    another_phone: 'Another Phone Number',
    building_number: 'Building number',
    street: 'Street',
    landmark: 'Landmark',
    floor: 'Floor',
    home: 'Apartment',
    address: 'Address',
    government_id: 'Governorate',
    grov_id: 'Governorate',
    city_id: 'Area',
    delivery_fees: 'delivery fees',
    note: 'note',
    warehouse_id: 'Warehouse',
    user_id: 'User',
    item: 'Product',
    quantity: 'quantity',
    price: 'price',
    product_id: 'Product ID',
    bundle_id: 'Bundle',
    bundle_qty: 'Bundle quantity',
    bundle_price: 'Bundle price',
  };

  const cleanField = field.replace(/\.\d+/g, '').replace(/\[\d+\]/g, '');
  return labels[cleanField] ? this.t(labels[cleanField]) : field;
}

private escapeHtml(value: any): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

private getBackendErrors(err: any): string[] {
  const body = err?.error;
  const messages: string[] = [];

  if (err?.status === 0) {
    return [this.t('Cannot connect to server. Please check your connection or server.')];
  }

  if (typeof body === 'string') {
    messages.push(body);
  }

  if (body?.error) {
    messages.push(body.error);
  }

  if (body?.message) {
    messages.push(body.message);
  }

  if (Array.isArray(body?.errors)) {
    body.errors.forEach((message: any) => messages.push(String(message)));
  }

  if (body?.errors && typeof body.errors === 'object' && !Array.isArray(body.errors)) {
    Object.entries(body.errors).forEach(([field, value]) => {
      const label = this.fieldLabel(field);

      if (Array.isArray(value)) {
        value.forEach((message) => {
          messages.push(`${label}: ${message}`);
        });
      } else if (value) {
        messages.push(`${label}: ${value}`);
      }
    });
  }

  const uniqueMessages = [...new Set(messages.filter(Boolean))];

  return uniqueMessages.length
    ? uniqueMessages
    : [this.t('Unexpected error happened. Please try again.')];
}

private showBackendErrors(err: any): void {
  let errors = this.getBackendErrors(err);

  errors = errors.map((message) => {
    if (message.includes('Not enough stock')) {
      const productId = message.match(/\d+/)?.[0];

      return this.t('Not enough stock for product ID', { productId: productId || '' });
    }

    return message;
  });

  this.backendErrors = errors;

  Swal.fire({
    icon: 'error',
    title: this.t('Order Failed'),
    html: `
      <div style="text-align:${this.isAr ? 'right' : 'left'}; direction:${this.isAr ? 'rtl' : 'ltr'}">
        <ul style="padding-${this.isAr ? 'right' : 'left'}:18px; margin:0;">
          ${errors.map((e) => `<li>${this.escapeHtml(e)}</li>`).join('')}
        </ul>
      </div>
    `,
    confirmButtonText: this.t('OK'),
  });
}
  generateQr(id: any, clientId: any, userId: any): void {
    const orderLink = `${window.location.origin}/Addorderclient?orderId=${id}&cart=${encodeURIComponent(JSON.stringify(this.arrayofids))}&client=${encodeURIComponent(clientId)}&prices=${encodeURIComponent(JSON.stringify(this.arrayofprices))}&page_id=${encodeURIComponent(userId)}`;
    console.log('Generated QR Link:', orderLink);
    this._orderService.generateLinkQr(orderLink, id).subscribe({
      next: (data) => console.log('QR Generated ✅:', data),
      error: (error) => console.error('QR Error ⛔:', error),
    });
  }
}
